/**
 * values to be used on form field rules tab, setting min/max units for strings and numbers
 */
import { locale } from './../../ModuleEditor/util/locale-wrapper';
import _ from 'lodash';

const MAX_LENGTH_UNITS = {
  CHARACTERS: 'characters',
  WORDS:      'words',
  VALUE:      'value',
  DIGITS:     'digits',
};

const MAX_LENGTH_TEXT_UNITS = [
  { text: locale('Characters'), value: MAX_LENGTH_UNITS.CHARACTERS },
  { text: locale('Words'), value: MAX_LENGTH_UNITS.WORDS },
];

const MAX_LENGTH_NUMBER_UNITS = [
  { text: locale('Value'), value: MAX_LENGTH_UNITS.VALUE },
  { text: locale('Digits'), value: MAX_LENGTH_UNITS.DIGITS },
];

const ALL_LENGTH_UNITS = MAX_LENGTH_TEXT_UNITS.concat(MAX_LENGTH_NUMBER_UNITS);

const MAX_LENGTH_UNITS_ALL = _.map(ALL_LENGTH_UNITS, 'value');

//for working easier with labels, we build out a {value: label} object
const MAX_LENGTH_UNITS_LABELS = _.reduce(
  ALL_LENGTH_UNITS,
  (ret, unit) => {
    ret[unit.value] = unit.text;
    return ret;
  },
  {}
);

const UNIT_TYPES = {
  LENGTH: 'length',
  VALUE:  'value',
};

export {
  MAX_LENGTH_UNITS,
  MAX_LENGTH_TEXT_UNITS,
  MAX_LENGTH_NUMBER_UNITS,
  MAX_LENGTH_UNITS_ALL,
  UNIT_TYPES,
  MAX_LENGTH_UNITS_LABELS,
};

export default MAX_LENGTH_UNITS;
